// src/blog-data.js

export const blogPosts = [
  {
    id: 7,
    slug: 'hochkonvertierende-website-schoenheitssalon-bayern',
    title: 'Der ultimative Leitfaden für eine hochkonvertierende Website für Schönheitssalons in Bayern',
    excerpt: 'So gewinnen Schönheitssalons in München, Nürnberg & ganz Bayern mehr Kunden mit einer konvertierenden Website, Online-Buchung, SEO und modernem Design.',
    category: 'web',
    image: 'https://images.pexels.com/photos/3992870/pexels-photo-3992870.jpeg?auto=compress&cs=tinysrgb&w=1200&h=628&dpr=2',
    imageDimensions: { width: 1200, height: 628 },
    date: '12. Juli 2025',
    author: 'Enzlo Team',
    readTime: '10 min',
    relatedPosts: [1, 2, 3]
  },
  {
    id: 1,
    slug: 'lokale-seo-handwerker-sueddeutschland',
    title: 'Wie Sie als Handwerker in Süddeutschland die lokalen Suchergebnisse dominieren können',
    excerpt: 'Erfahren Sie, wie Sie mit lokaler SEO-Optimierung Mehr Kunden gewinnen und Ihre Online-Präsenz maximieren können.',
    category: 'seo',
    image: 'https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&w=1200&h=628&dpr=2',
    imageDimensions: { width: 1200, height: 628 },
    date: '11. Juli 2025',
    author: 'Enzlo Team',
    readTime: '8 min',
    relatedPosts: [2, 5, 6]
  },


  {
    id: 2,
    slug: 'online-marketing-strategien-kleine-unternehmen',
    title: 'Die 7 wichtigsten Online-Marketing-Strategien für kleine Unternehmen',
    excerpt: 'Entdecken Sie bewährte Marketing-Taktiken, die auch mit kleinem Budget große Wirkung erzielen können.',
    category: 'marketing',
    image: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1200&h=628&dpr=2',
    imageDimensions: { width: 1200, height: 628 },
    date: '5. Juli 2025',
    dateISO: '2025-07-05',
    author: 'Franziska Spoddig',
    readTime: '6 min',
    tableOfContents: [],
    relatedPosts: [1, 5, 6]
  },
  {
    id: 5,
    slug: 'google-business-profile-guide',
    title: 'Google Business Profile: Der ultimative Guide für lokale Unternehmen',
    excerpt: 'Maximieren Sie Ihre lokale Sichtbarkeit mit einem perfekt optimierten Google Business Profile.',
    category: 'seo',
    image: '/images/blog/google-business-profile.jpg',
    imageDimensions: { width: 1200, height: 628 },
    date: '15. Juni 2025',
    dateISO: '2025-06-15',
    author: 'Enzlo Team',
    readTime: '9 min',
    tableOfContents: [],
    relatedPosts: [1, 2, 6]
  },
  {
    id: 6,
    slug: 'content-marketing-expertise',
    title: 'Wie Sie mit Content-Marketing Ihre Expertise zeigen',
    excerpt: 'Qualitativ hochwertiger Content ist der Schlüssel, um als Experte in Ihrer Branche wahrgenommen zu werden.',
    category: 'content',
    image: '/images/blog/content-marketing-expertise.jpg',
    imageDimensions: { width: 1200, height: 628 },
    date: '8. Juni 2025',
    dateISO: '2025-06-08',
    author: 'Franziska Spoddig',
    readTime: '6 min',
    tableOfContents: [],
    relatedPosts: [1, 5, 2]
  },
  {
    id: 3,
    slug: 'mobile-first-strategie-website',
    title: 'Warum Ihre Website eine Mobile-First-Strategie braucht',
    excerpt: 'Über 70% der Websitebesucher nutzen mobile Geräte. Ist Ihre Website dafür optimiert?',
    category: 'web',
    image: 'https://images.pexels.com/photos/34407/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=1200&h=628&dpr=2',
    imageDimensions: { width: 1200, height: 628 },
    date: '28. Juni 2025',
    author: 'Enzlo Team',
    readTime: '5 min',
    relatedPosts: [1, 7, 5]
  },
  {
    id: 4,
    slug: 'social-media-b2b-unternehmen',
    title: 'Social Media für B2B-Unternehmen: So geht\'s richtig',
    excerpt: 'Auch im B2B-Bereich können Sie mit der richtigen Social-Media-Strategie Leads generieren und Ihre Marke stärken.',
    category: 'social',
    image: 'https://images.pexels.com/photos/265087/pexels-photo-265087.jpeg?auto=compress&cs=tinysrgb&w=1200&h=628&dpr=2',
    imageDimensions: { width: 1200, height: 628 },
    date: '20. Juni 2025',
    author: 'Franziska Spoddig',
    readTime: '7 min',
    relatedPosts: [2, 5, 6]
  }
];
